import { useMemo } from 'react';

import { HoverCardWithIcon } from '@/common/components/shared/hover-card/HoverCardWithIcon';
import type { UseContractTypePersistenceReturn } from '@/common/hooks/employees/useContractTypePersistence';

interface Props {
  allContractTypes: UseContractTypePersistenceReturn['data'] | undefined;
}

export const TooltipGreenhouseLink = ({ allContractTypes }: Props) => {
  const emptyTypes = useMemo(() => {
    const array = allContractTypes?.filter(it => it.greenhouseLinkCanBeEmpty).map(it => `"${it.displayName}"`) ?? [];

    if (array.length === 0) {
      return ' ';
    }

    const lastOne = array.pop();
    return ` except ${array.join(', ')} and ${lastOne} employees `;
  }, [allContractTypes]);

  return (
    <HoverCardWithIcon position="top">
      <span>All employees</span>
      <span>{emptyTypes}</span>
      <span>are required to fill the URL. Attach the offer letter and ensure it is marked as hired.</span>
    </HoverCardWithIcon>
  );
};
